import { bytesToHex, utf8Encode } from '../crypto/encoding';

// The anonymous token is the ONLY identifier ever sent to Box C. It is
// HMAC-SHA256(anonIdKey, "cruzfind.anon.v1"), full 32 bytes → 64 hex chars.
// - Deterministic per master key: same password → same token, so the server can
//   recognise a returning user without storing the password or master key.
// - Cannot be reversed to recover the password, email, or master key.
// - Cannot be linked across two different users (each user's anonIdKey is unique).
const ANON_TOKEN_PLAINTEXT = utf8Encode('cruzfind.anon.v1');

export async function computeAnonToken(anonIdKey: CryptoKey): Promise<string> {
  const sig = await crypto.subtle.sign('HMAC', anonIdKey, ANON_TOKEN_PLAINTEXT);
  return bytesToHex(new Uint8Array(sig));
}
